import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DeleteAccount from "@/pages/DeleteAccount";
import Settings from "@/pages/Settings";
import HashtagPage from "@/pages/HashtagPage";
import PublicPost from "@/pages/PublicPost";
import AdminModeration from "@/pages/AdminModeration";
import Profile from "@/pages/Profile";
import Itinerary from "@/pages/Itinerary";
import Concierge from "@/pages/Concierge";
import TripDashboard from "@/pages/TripDashboard";
import PublicTrip from "@/pages/PublicTrip";
import Discover from "@/pages/Discover";
import DiscoverPlanDetail from "@/pages/DiscoverPlanDetail";
import Support from "@/pages/Support";
import OwnerCommandCenter from "@/pages/OwnerCommandCenter";
import EventsAdmin from "@/pages/EventsAdmin";
import TravelDate from "@/pages/TravelDate";
import TravelDateDetail from "@/pages/TravelDateDetail";
import TravelDateHistory from "@/pages/TravelDateHistory";
import TravelDatePublic from "@/pages/TravelDatePublic";
import VerifyEmail from "@/pages/VerifyEmail";
import ReelDeepLink from "@/pages/ReelDeepLink";
import MessagesPage from "@/pages/MessagesPage";
import { PassportShareProvider } from "@/components/messages/PassportShareProvider";
import { useEffect } from "react";
import { registerServiceWorker, pushSupported } from "@/lib/push";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    useEffect(() => {
        if (pushSupported()) {
            registerServiceWorker();
        }
    }, []);
    return (
        <div className="App">
            <AuthProvider>
                <PassportShareProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/auth" element={<Auth />} />
                            <Route path="/auth/callback" element={<AuthCallback />} />
                            <Route path="/verify-email" element={<VerifyEmail />} />
                            <Route path="/reel/:reelId" element={<ReelDeepLink />} />
                            <Route path="/app" element={<Dashboard />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/messages" element={<MessagesPage />} />
                            <Route path="/payment/success" element={<PaymentSuccess />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/delete-account" element={<DeleteAccount />} />
                            <Route path="/hashtag/:tag" element={<HashtagPage />} />
                            <Route path="/p/:slug" element={<PublicPost />} />
                            <Route path="/u/:handle" element={<Profile />} />
                            <Route path="/profile/:handle" element={<Profile />} />
                            <Route path="/itinerary/:id" element={<Itinerary />} />
                            <Route path="/concierge" element={<Concierge />} />
                            <Route path="/plan" element={<Navigate to="/concierge" replace />} />
                            <Route path="/discover" element={<Discover />} />
                            <Route path="/discover/trips/:id" element={<DiscoverPlanDetail kind="trip" />} />
                            <Route path="/discover/dates/:id" element={<DiscoverPlanDetail kind="traveldate" />} />
                            <Route path="/support" element={<Support />} />
                            <Route path="/owner" element={<OwnerCommandCenter />} />
                            <Route path="/admin/local-events" element={<EventsAdmin />} />
                            <Route path="/traveldate" element={<TravelDate />} />
                            <Route path="/traveldate/history" element={<TravelDateHistory />} />
                            <Route path="/traveldate/share/:slug" element={<TravelDatePublic />} />
                            <Route path="/traveldate/:id" element={<TravelDateDetail />} />
                            <Route path="/trip/share/:slug" element={<PublicTrip />} />
                            <Route path="/trip/:id" element={<TripDashboard />} />
                            <Route path="/admin/moderation" element={<AdminModeration />} />
                        </Routes>
                    </BrowserRouter>
                </PassportShareProvider>
                <Toaster
                    theme="dark"
                    position="bottom-center"
                    toastOptions={{
                        style: {
                            background: "#050A11",
                            border: "1px solid rgba(212,175,55,0.3)",
                            color: "white",
                            fontFamily: "Outfit, sans-serif",
                        },
                    }}
                />
            </AuthProvider>
        </div>
    );
}

export default App;
